<template>
	<div class="table-responsive">
		<table class="table table-row-bordered">
			<thead>
				<tr class="fw-bold fs-6">
					<th>Descrição</th>
					<th>Nome</th>
					<th>Tipo</th>
					<th>Espaço livre disponível</th>
					<th>Tamanho</th>
					<th>Partição do boot</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="partition in props.partitions">
					<td>{{ partition.description }}</td>
					<td>{{ partition.device_id }}</td>
					<td>{{ partition.file_system }}</td>
					<td>{{ partition.free_space }}</td>
					<td>{{ partition.size }}</td>
					<td>
						{{ partition.boot_partition === '1' ? 'Sim' : 'Não' }}
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script setup lang="ts">
	interface Partition {
		description: string;
		device_id: string;
		file_system: string;
		free_space: any;
		size: any;
		boot_partition: string;
	}

	const props = defineProps({
		partitions: { type: Array<Partition>, required: true },
	});

	props.partitions.forEach((item) => {
		if (parseInt(item.free_space) > 0) {
			item.free_space =
				(item.free_space / (1024 * 1024 * 1024)).toFixed(1) + 'GB';
		}

		if (parseInt(item.size) > 0) {
			item.size =
				Math.ceil(item.size / (1024 * 1024 * 1024)).toFixed(1) + 'GB';
		}
	});
</script>
